import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventCity {
	cityCd: string;
	cityNm: string;
	currCd: string;
	timeDiff: string;
}

interface EventExchange {
	currCd: string;
	exchNm: string;
	exchRat: number;
	exchDt: string;
}

interface EventLocal {
	nowDate: string;
	cityInfo: EventCity[];
	exchangeInfo: EventExchange[];
}

/** ```
 * 행사 현지 정보
 *   `/pkg/event/{eventCode}/local`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventLocal";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event/${evCd}/local`;
};

/** ```
 * 행사 현지 정보
 *   `/pkg/event/{eventCode}/local`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventLocal = (evCd: string, options?: Partial<UseQueryOptions<Response<EventLocal>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useEventLocal;
export {getPath};
export type {EventCity, EventExchange, EventLocal};
